module.exports = __webpack_public_path__ + "static/media/logo.aecd0d3b.svg";